import { render, staticRenderFns } from "./paymentqrCode.vue?vue&type=template&id=57b12973&scoped=true"
import script from "./paymentqrCode.vue?vue&type=script&lang=js"
export * from "./paymentqrCode.vue?vue&type=script&lang=js"
import style0 from "./paymentqrCode.vue?vue&type=style&index=0&id=57b12973&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57b12973",
  null
  
)

export default component.exports